import axios, { AxiosResponse } from "axios"

export function fetchHealthCheck(token: string): Promise<AxiosResponse> {
    return axios.get(
        "https://stg-api.transitxchange.cloud/api/v1/ctxr/-1/healthcheck?tenantId=1&cloud=&region=",
        { headers: { Authorization: `Bearer ${token}` } }
    )
}
